<template>
  <div class="banner" v-if="!isMobile">
    <!-- <img src="../../../assets/img/banner-shdow.png" alt=""> -->
    <div class="bg"></div>
    <div class="mask"></div>

    <!-- <div class="logo"><img src="@/assets/img/mobile/logo.png" alt=""></div> -->
    <!-- <div class="language" :class="isEn ? 'en' : ''">
      <span @click="setLang('zh-CN')">中文</span>
      <span @click="setLang('en-US')">EN</span>
    </div> -->

    <video ref="bannerVideo" :src="videoLink" preload muted="muted" loop="true" :autoplay="true"></video>
  </div>
  <div class="banner mobile" v-else>
    <img :src="registerBg" alt="">

    <!-- <div class="button" v-if="isMobile">
      <a href="https://jinshuju.net/f/jSJSFt" target="_blank">
        <div class="hover"></div>
        <img :src="registerImg" alt="立即报名" />
      </a>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      isLoad: false,
      isEn: false
    }
  },
  props: ['data'],
  computed: {
    ...mapState(['isMobile', 'isEnLang']),
    registerImg () {
      return this.isEnLang ? require('../../../assets/img/en/sign_up.png') : require('../../../assets/img/nav-btn.png')
    },
    registerBg () {
      return this.isMobile ? 'https://static001.geekbang.org/resource/image/bc/84/bcf7c7a8c8f390a8a1ec9b84d0cd2984.jpg' : 'https://static001.geekbang.org/resource/image/bc/84/bcf7c7a8c8f390a8a1ec9b84d0cd2984.jpg'
    },
    videoLink () {
      return 'https://static001.geekbang.org/static/biz/file/webank/banner.mp4'
    }
  },
  mounted () {
    const that = this
    if (!that.isMobile) {
      const video = that.$refs.bannerVideo
      video.addEventListener('canplaythrough', function () {
        that.isLoad = true
        setTimeout(function(){
          video.play()
        },300)
      })
    }
  },
  methods: {
    ...mapActions([
      'setLang'
    ])
    // changeLang (type) {
    //   if(this.isEn) {
    //     if (type === 'cn') {
    //       this.isEn = false
    //       window.location.pathname = '/fintechathon/campus2019'
    //       // window.location.href = 'http://localhost:8091/fintechathon/campus2019'
    //     } else {
    //       return
    //     }
    //   } else {
    //     if (type === 'en') {
    //       this.isEn = true
    //       window.location.pathname = '/en/fintechathon/campus2019'
    //       // window.location.href = 'http://localhost:8090/en/fintechathon/campus2019'
    //     } else {
    //       return
    //     }
    //   }
    // }
  },
}
</script>

<style lang="sass" scope>
$title-primary: #1075d4

.language
  position: absolute
  right: 20px
  top: 120px
  z-index: 21
  width: 140px
  height: 40px
  display: flex
  align-items: center
  color: #fff
  background: url(~@/assets/img/lang-cn.png) no-repeat center center/100% 100%
  span
    flex: 1
    text-align: center
    font-size: 18px
    cursor: pointer
    &:first-child
      padding-left: 10px
    &:last-child
      padding-right: 10px
.language.en
  background: url(~@/assets/img/lang-en.png) no-repeat center center/100% 100%
.banner
  width: 100%
  height: 47vw
  position: relative
  overflow: hidden
  +mobile
    height: 100%
  .bg
    width: 100%
    height: 100%
    background: url('https://static001.geekbang.org/resource/image/5e/4d/5ebc26613e512763b1be20521fe2614d.png') no-repeat center center/cover
  .logo
    position: absolute
    top: 20px
    left: 20px
    width: 250px
    z-index: 19
  .mask
    position: absolute
    bottom: 0
    left: 0
    z-index: 99
    width: 100%
    height: 30%
    background: linear-gradient(to top, #13101a, transparent)
  .poster
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    z-index: 20
    transition: all .7s
    &.isLoad
      opacity: 0
  video
    position: absolute
    top: -5vw
    left: 0
    width: 100%
    margin-top: 67px
    // height: 56vw
    font-size: 0

.banner.mobile
  // height: 132.6vw
  margin-top: 55px
  overflow: visible
  img
    width: 100%
  .button
    width: 180px
    height: 50px
    line-height: 50px
    text-align: center
    color: #fff
    cursor: pointer
    font-size: 18px
    // background: linear-gradient(-30deg,rgba(255,0,84,1),rgba(43,112,251,1))
    border-radius: 5px
    position: absolute
    bottom: 13%
    left: 50%
    transform: translateX(-50%)
    &:hover
      .hover
        box-shadow: 0px 0px 20px 30px rgba($blue,.2)
    img
      position: absolute
      z-index: 1
      width: 100%
    .hover
      position: absolute
      top: 20px
      left: 20px
      right: 20px
      bottom: 20px
      @extend %transition
</style>
